import { createStore } from '@souche-f2e/muji';
import { login, logout, userInfo, resetPasswd } from '../services/user';
import { save,load } from '../utils/localstore';
import { message } from 'antd';

const state = {
  user: null,
  isLogin: null,
  hasUserInfoCache: false,
  loginErrMsg: null
};

const localStoreName = 'user_config';


export default createStore({
  state,

  // reducers
  reducers: {
    LOAD_USER(state) {
      const user = load(localStoreName);

      if(!user) {
        return state;
      }

      return {
        ...state,
        user,
        hasUserInfoCache: true
      }
    },

    UPDATE_USER(state, { user }) {

      if (user) {
        save(localStoreName, user);
      }

      return {
        ...state,
        isLogin: true,
        hasUserInfoCache: true,
        user
      }
    },

    CLEAN_USER(state) {
      save(localStoreName, null);

      return {
        ...state,
        hasUserInfoCache: false,
        user: null
      };
    },
    UPATE_APP_NEW_DESC(state, { payload: { description, appId } }) {
      const stateIpMap = state.ipMap;
      stateIpMap[appId] = stateIpMap[appId] || {};
      stateIpMap[appId].description = description;

      return {
        ...state,
        ipMap: stateIpMap
      };
    },

    SET_LOGIN_ERROR_MSG(state, { msg }) {
      return {
        ...state,
        loginErrMsg: msg
      }
    },

    SET_LOGIN_STATUS(state, { login = false }) {
      return {
        ...state,
        isLogin: login,
      }
    },

    SET_FETCH_INFO(state, { fetchInfo = true }) {
      return {
        ...state,
        fetchInfo
      }
    }
  },

  // effects
  effects: {
    async login({ username, password }) {
      const body = await login({ username, password }).promise;

      const { success, data }  = body;
      const { user, loginStatus } = data;

      if (success && loginStatus) {
        message.info('登录成功!');
        this.SET_LOGIN_STATUS({ login: true });
        this.UPDATE_USER({ user });
        this.SET_LOGIN_ERROR_MSG({ msg: null });
      } else {
        this.CLEAN_USER();
        this.SET_LOGIN_ERROR_MSG({ msg: '登录失败' })
        this.SET_LOGIN_STATUS({ login: false });
      }
    },

    async logout() {
      await logout().promise;

      message.info('退出账号成功!');

      this.CLEAN_USER();
      this.SET_LOGIN_STATUS({ login: false });
    },

    async userinfo() {
      const body = await userInfo().promise;

      const { success, data }  = body;
      const { user } = data;

      if (success) {
        this.UPDATE_USER({ user });
        this.SET_LOGIN_STATUS({ login: true });
      } else {
        this.CLEAN_USER();
        this.SET_LOGIN_STATUS({ login: false });
      }
    }
  },
});